<template>
  <div>
    <div class="top_bg">
      <img src="@/assets/images/product_bg.jpg" alt="">
    </div>
    <div class="defult_title">
        <h1>{{language === 'E' ? 'SUCCESS CASE' : '案例展示'}}</h1>
        <p>{{language === 'E' ? '案例展示' : 'SUCCESS CASE'}}</p>
      </div>
    <div class="defult_width sharing-list">
      <el-row class="news-box" :gutter="20">
        <el-col :span="6" v-for="(item, key) in coreValuesList" :key="key">
          <div class="img-box">
            <router-link :to="`sharingDetail/${item.id}`" v-if="(key+1)%2 == 0">
              <img :src="item.img" :alt="item.name">
              <div class="detail-box">
                <span>
                  {{ item.name }}
                </span>
                <p>
                  {{ (item.detail).substring(0, 75) + '...' }}
                </p>
              </div>
            </router-link>
            <router-link :to="`sharingDetail/${item.id}`" v-else>
             <div class="detail-box">
                <span>
                  {{ item.name }}
                </span>
                <p>
                  {{ (item.detail).substring(0, 75) + '...' }}
                </p>
              </div>
              <img :src="item.img" :alt="item.name">
            </router-link>
          </div>
        </el-col>
        <!-- <el-col :span="14">
           <ul>
            <li v-for="(item, key) in coreValuesList" :key="key"  v-show="key >= (currentPage - 1) * 8 && key < (currentPage * 8) - 5">
              <router-link :to="`sharingDetail/${item.id}`">
                <div class="list">
                    <h5>
                    {{ item.name }}
                    </h5>
                    <p>
                      {{ (item.detail).substring(0, 75) + '...' }}
                    </p>
                </div>
              </router-link>
            </li>
          </ul>
        </el-col> -->
      </el-row>
    </div>
  </div>
</template>
<script>
import index from '@/datas/index'
import Eindex from '@/EnglishData/index'
export default {
  name: 'coreValuesList',
  data () {
    const language = localStorage.getItem('language')
    let languageIndex = null
    if (language && language === 'E') {
      languageIndex = Eindex
    } else {
      languageIndex = index
    }
    const { coreValuesList } = languageIndex
    return {
      coreValuesList, // 列表
      language,
      currentPage: 1 // 当前页数
    }
  },
  created () {
  },
  methods: {
    currentChange (page) {
      this.currentPage = page
    }
  }
}
</script>
<style lang="less" scoped>
.sharing-list {
  padding: 20px 0 50px;
  .news-box {
    .img-box {
      box-shadow: 0 0 10px rgba(51,51,51,0.1);
      margin-bottom: 40px;
      height: 430px;
      overflow: hidden;
      a {
        font-size: 0;
        img {
          width: 100%;
          height: 280px;
          display: block;
          transition: all .5s;
        }
        .detail-box {
          padding: 0 20px;
          height: 150px;
          text-align: left;
          background: #fff;
          transition: all .2s;
           span {
            display: inline-block;
            color: #333;
            font-size: 16px;
            padding-top: 20px;
          }
          p {
            padding: 10px 0 20px;
            color: #666;
          }
        }
      }
      &:hover {
        a {
          img {
            transform: scale(1.05);
          }
          .detail-box {
            background: #0075c1;
            span,p {
              color: #fff;
            }
          }
        }

      }

    }
    // ul {
    //   display: flex;
    //   justify-content: space-between;
    //   flex-wrap: wrap;
    //   li {
    //     width: 100%;
    //     a {
    //       display: block;
    //       overflow: hidden;
    //       .list {
    //         text-align: left;
    //         h5 {
    //           font-size: 18px;
    //           color: #4a4a4a;
    //           line-height: 30px;
    //         }
    //         p {
    //           line-height: 24px;
    //           min-height: 80px;
    //           color: #767676;
    //         }
    //       }
    //     }
    //   }
    // }

  }
//  .next-box {
//     padding-top: 70px;
//     border-top: 1px dashed #f2f2f2;
//     .img-box {
//       display: inline-block;
//       text-align: right;
//     }
//   }
}
</style>



// WEBPACK FOOTER //
// src/view/TechnologySharing/sharingList.vue